"use strict";
define('core/beautify-options',[], function() {
  // See http://jsbeautifier.org/js/lib/beautify-html.js
  // For what each one means.
  return Object.freeze({
    'brace_style': 'expand',
    'extra_liners': ['section'],
    'indent_char': ' ',
    'indent_handlebars': false,
    'indent_inner_html': false,
    'indent_size': 2,
    'max_preserve_newlines': 5,
    'preserve_newlines': true,
    'wrap_line_length': 0,
  });
});

